import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-redirect',
  templateUrl: './success-redirect.component.html',
  styleUrls: ['./success-redirect.component.scss']
})
export class SuccessRedirectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
